export enum BuildingLayoutPricingMethod {
  ComponentOnly = 'component-only',
  LayoutAndComponent = 'layout-and-component',
  LayoutOnly = 'layout-only',
}
